
interface MembershipTier {
  id: string;
  name: string;
  price: number;
  perks: string[];
  memberCount: number;
}

interface MembershipTiersProps {
  tiers: MembershipTier[];
  onJoinMembership: (tierId: string) => void;
}

export default function MembershipTiers({ tiers, onJoinMembership }: MembershipTiersProps) {
  return (
    <section className="bg-white rounded-lg border border-neutral-200 p-6">
      <div className="mb-6">
        <h2 className="text-xl font-bold text-gray-900 mb-2">Memberships</h2>
        <p className="text-sm text-gray-600">
          Become a member to fund new music and get exclusives. Cancel anytime.
        </p>
      </div>

      <div className="space-y-4">
        {tiers.map((tier, index) => (
          <div
            key={tier.id}
            className={`border rounded-lg p-4 ${
              index === 0 
                ? 'border-emerald-200 bg-emerald-50' 
                : 'border-gray-200 bg-white'
            }`}
          >
            <div className="flex items-start justify-between mb-4">
              <div>
                <h3 className="font-semibold text-gray-900 mb-1">{tier.name}</h3>
                <p className="text-2xl font-bold text-emerald-600">
                  KES {tier.price}
                  <span className="text-sm font-normal text-gray-500">/month</span>
                </p>
                <p className="text-xs text-gray-500 mt-1">
                  {tier.memberCount} members
                </p>
              </div>
              <button
                onClick={() => onJoinMembership(tier.id)}
                className={`px-4 py-2 rounded-lg font-semibold transition-colors whitespace-nowrap ${
                  index === 0
                    ? 'bg-emerald-600 hover:bg-emerald-700 text-white'
                    : 'bg-gray-900 hover:bg-gray-800 text-white'
                }`}
              >
                Join Tier
              </button>
            </div>

            <ul className="space-y-2">
              {tier.perks.map((perk, perkIndex) => (
                <li key={perkIndex} className="flex items-start text-sm text-gray-600">
                  <i className="ri-check-line text-emerald-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  {perk}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-4 p-3 bg-gray-50 rounded-lg">
        <p className="text-xs text-gray-600 text-center">
          <i className="ri-shield-check-line text-emerald-600 mr-1"></i>
          Direct artist support • Cancel anytime • Secure payments
        </p>
      </div>
    </section>
  );
}
